import { useCallback, useState } from "react";
import { useAccount, useChainId, useSignMessage } from "wagmi";
import { api, setJwt } from "@/lib/api";
import { useAuthStore } from "@/stores/auth";

type NonceResponse = { nonce: string; expiresAt: number };
type VerifyResponse = { token: string; address: string; chainId: number };

export function useSiwe() {
  const { address } = useAccount();
  const chainId = useChainId();
  const { signMessageAsync } = useSignMessage();
  const signIn = useAuthStore((s) => s.signIn);
  const [loading, setLoading] = useState(false);

  const perform = useCallback(async () => {
    if (!address) throw new Error("no wallet connected");
    setLoading(true);
    try {
      const { nonce } = await api.post<NonceResponse>("/api/siwe/nonce");
      const issuedAt = new Date().toISOString();
      const uri = window.location.origin;
      const domain = window.location.host;
      const message = [
        `${domain} wants you to sign in with your Ethereum account:`,
        address,
        "",
        "Sign in to Atelier.",
        "",
        `URI: ${uri}`,
        "Version: 1",
        `Chain ID: ${chainId}`,
        `Nonce: ${nonce}`,
        `Issued At: ${issuedAt}`,
      ].join("\n");
      const signature = await signMessageAsync({ message });
      const result = await api.post<VerifyResponse>("/api/siwe/verify", { message, signature });
      setJwt(result.token);
      signIn(result.token, result.address, result.chainId);
      return result;
    } finally {
      setLoading(false);
    }
  }, [address, chainId, signMessageAsync, signIn]);

  return { perform, loading };
}
